import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  getDriver,
  postAddDriver,
  patchUpdateDriver,
} from 'redux/actions/UserDriver';
import { debounce } from 'lodash';
import CommonTable from 'components/commonTable/CommonTable';
import CommonButtonSubHeader from 'components/commonButtonSubHeader/CommonButtonSubHeader';
import BackDrop from 'components/backDrop/BackDrop';
import CommonDialog from 'components/commonDialog/CommonDialog';
import Loader from 'components/loader/Loader';
import useModal from 'hooks/useModal';
import { driverDialogData } from './DriverData';
import { filterdata } from 'pages/vehicle/VehiceData';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import { handlePermissions } from 'utils/utils';
import CommonMultiImageForm from 'components/commonMultiImageForm/CommonMultiImageForm';
import { getOnBoardCompliance } from 'redux/actions/UserCompliance';

const Drivers = () => {
  const dispatch = useDispatch();
  const {state} = useLocation();
  const tableData = useSelector((state) => state?.userDriver?.userDriver?.data);
  const profileData = useSelector(
    (state) => state?.userProfile?.userProfile?.data
  );
  const loader = useSelector((state) => state?.userDriver?.loading);
  const { open, toggle } = useModal();
  const userID = localStorage.getItem('ID');
  const companyId = localStorage.getItem('companyId');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [defaultValue, setDefaultValue] = useState({});
  const [type, setType] = useState('');
  const [id, setId] = useState(null);
  const [status, setStatus] = useState(state?.driverStatus ? state?.driverStatus?.split(','):'');
  const [search, setSearch] = useState('');
  const [modelOpen, setModelOpen] = useState(false);
  const [showOtherComponent, setShowOtherComponent] = useState(false);
  const [image, setImage] = useState(null);
  
  useEffect(() => {
    dispatch(getDriver(filterData));
  }, []);

  let filterData = {
    id: state?.companyType === 'adminCompany' ? '':companyId,
    status: status,
    page: page,
    pageSize: rowsPerPage,
    date: '',
    duration: '',
    type: 'driver',
    search: search,
  };

  const tableOnClickRow = (navigate, val) => {
    navigate(`/driver/details`, {
      state: { id: val.id, name: val.name,status:val?.status },
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(getDriver({ ...filterData, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(
      getDriver({
        ...filterData,
        page: 0,
        pageSize: parseInt(event.target.value),
      })
    );
  };

  //Filter functions
  const onFilterChange = (val) => {
    setPage(0);
    const defaultStatus = ['Active', 'InActive', 'Blocked', 'Pending'];
    const filterStatus = val.filter((status) => {
      return defaultStatus.includes(status);
    });

    setStatus(filterStatus);
    const driverFilterData = {
      ...filterData,
      status: filterStatus?.toString(),
      page: 0,
    };
    dispatch(getDriver(driverFilterData));
  };

  const onRestFilter = () => {
    setStatus('')
    filterData = { ...filterData, status: '' };
    dispatch(getDriver(filterData));
  };

  const onSearch = debounce((e) => {
    setPage(0);
    setSearch(e);
    const searchFilterData = {
      ...filterData,
      search: e,
      page: 0,
    };
    dispatch(getDriver(searchFilterData));
  }, 1000);

  //submit driver data

  const onDialog = (val) => {
    const data = {
      mobile: val.number,
      firstName: val.driverName,
      lastName: '',
      email: val.email,
      countryCode: '+91',
      parentId: companyId,
      companyName: 'abc12121qw' + val.number,
      isB2B:'true',
      avtar: image,
    };
    dispatch(postAddDriver(data));
    toggle();
  };

  //---Update Driver
  const onSubmit = (data, code) => {
    const profileData = {
      driverId: id,
      parentId: companyId,
      page:page,
      pageSize:rowsPerPage,
      data: {
        firstName: data?.driverName,
        lastName: '',
        email: data?.email,
        countryCode: '+91',
        mobile: data?.number,
        companyName: '',
        name: data?.vendorName,
        isB2B: 'true',
      },
    };
    dispatch(patchUpdateDriver(profileData));
    setModelOpen(false);
  };

  const onClickMoreIcon = (data, type) => {
    const value = {
      driverName: data?.name?.trim(),
      email: data?.email,
      number: data?.mobile,
      currentaddress: data?.address,
      city: data?.city,
      state: data?.state,
      name: data?.vendorName,
      avtar: image,
    };
    setDefaultValue(value);
    setId(data.id);

    let statusAction = '';
    switch (type) {
      case 'Deactivate':
        statusAction = 'InActive';
        break;
      case 'Activate':
        statusAction = 'Active';
        break;
      case 'Block':
        statusAction = 'Blocked';
        break;
      case 'Unblock':
        statusAction = 'Active';
        break;
      default:
        break;
    }
    if (type === 'Edit') {
      setType(type);
      setModelOpen(true);
    } else if (type === 'Upload Compliance') {
          setType(type);
          setModelOpen(true);
          const profileData = {
            driverId: data.id,
            type: 'driverRegistration',
          };
          setShowOtherComponent(true);
          dispatch(getOnBoardCompliance(profileData));
        }
    else if (statusAction !== '') {
      const profileData = {
        driverId: data.id,
        parentId: companyId,
        page:page,
        pageSize:rowsPerPage,
        search:search,
        status: status,
        data: {
          status: statusAction,
          isB2B: 'true',
        },
      };
      dispatch(patchUpdateDriver(profileData));
    }
  };

  const defaultVendor = {
    name: tableData?.body[0]?.vendorName,
    subVendor: profileData?.companyName,
  };

  const handleClose = () => {
    setModelOpen(false);
    setShowOtherComponent(false);
  };

   const onImageChange = (val) => {
    setImage(val);
  };

  const handleSkipCompliance = () => {
    if (id) {
      const profileData = {
        driverId: id,
        parentId: companyId,
        page: page,
        pageSize: rowsPerPage,
        search: search,
        status: status,
        data: {
          status: 'Active',
          isB2B: 'true',
        },
      };
      dispatch(patchUpdateDriver(profileData));
    }
    handleClose();
  };

  //roles and permissions 
  const roleAndPermissions = useSelector((state) => state?.getRolesAndPermissions?.rolesAndPermissions);
  const driverRoleEnum = roleAndPermissionEnum.driver
  const accessForAdd = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {defaultAllAccess: driverRoleEnum.all, customAccess: driverRoleEnum.add});
  const accessForOnlyView = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {customAccess: driverRoleEnum.subVendorView});
  const accessForOnlyEdit = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {customAccess: driverRoleEnum.subVendorEdit});
  const accessForOnlyActivate = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {customAccess: driverRoleEnum.subVendorActivate});

  const accessForOnlyBlock = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {customAccess: driverRoleEnum.subVendorBlock});

  const accessForOnlyAdd = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {customAccess: driverRoleEnum.subVendorAdd});

  const viewMoreIcon = (accessForAdd || accessForOnlyEdit || accessForOnlyActivate||accessForOnlyBlock )
  const addButton = (accessForAdd ||accessForOnlyAdd )

  return (
    <Box className="driverContainer">
      <CommonButtonSubHeader
        btnName={addButton && 'Driver'}
        filterdata={filterdata}
        btnAction={toggle}
        onRestFilter={onRestFilter}
        onFilterChange={onFilterChange}
        tabName={'company'}
        // search={'true'}
        height={true}
        onSearchQuery={onSearch}
        defaultStatus={status}
      />
      {loader ? (
          <Loader/>
      ) : (
        <CommonTable
          data={tableData}
          tableOnClickRow={tableOnClickRow}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          page={page}
          rowsPerPage={rowsPerPage}
          onClickMoreIcon={onClickMoreIcon}
          isClickable={true}
          viewMoreIcon={!viewMoreIcon}
          tabName={'driver'}
        />
      )}

      <CommonDialog
        className="mb20"
        open={open}
        handleClose={toggle}
        button={'dialogButton'}
        onSubmittBtn={onDialog}
        selectType={'Create'}
        type={'Driver'}
        defaultValues={defaultVendor}
        formData={driverDialogData}
      />

      {modelOpen && (type === 'Edit') ? (
        <CommonDialog
          open={modelOpen}
          handleClose={handleClose}
          formData={driverDialogData}
          button={'dialogButton'}
          onSubmittBtn={onSubmit}
          type={'Edit ' + 'Driver' + ' '}
          selectType={'edit'}
          defaultValues={defaultValue}
        />
      ) : 
      (
              <CommonMultiImageForm
                open={modelOpen}
                handleClose={handleClose}
                formData={driverDialogData}
                button={'dialogButton'}
                onSubmittBtn={onDialog}
                selectType={'edit'}
                type={'Upload Driver Compliance'}
                defaultValues={defaultValue}
                onImageChange={onImageChange}
                showOtherComponent={showOtherComponent}
                tabName="driver"
                driverId={id}
                onSkipCompliance={handleSkipCompliance}
              />
            )}
    </Box>
  );
};

export default Drivers;
